<template lang="html">

  <section class="menu-superior row-between" :style="styles.bgbody">

    <h2 class="nombre" :move="showMenu">Hola {{ name }}</h2>

    <div class="row-end ais">

      <template v-if="!!doc">
        <a class="button actilla column-between" :href="doc.url" :style="styles.colorBasic" target="_blank"
          :title="doc.title">
          <icon-download-doc></icon-download-doc>
          <span v-html="doc.texto"></span>
        </a>
      </template>

      <template>
        <button class="button actilla column-between" @click="showPopup = true" :style="styles.colorBasic">
          <icon-download-doc></icon-download-doc>
          <span>{{ $t('descargar_certificado') }}</span>
        </button>
        <!-- <a class="button actilla column-between" :href="certificadoPracticas[lang]" :style="styles.colorBasic"
          target="_blank" title="Descargar certificado de prácticas">
          <icon-download-doc></icon-download-doc>
          <span>{{ $t('descargar_certificado') }}</span>
        </a> -->
      </template>

      <a @click="logout" class="button column-between" :style="styles.colorBasic">
        <icon-salir></icon-salir>
        salir
      </a>
    </div>
    <div class="cover-popup row-center -certificado" v-if="showPopup">
      <div class="popup">
        <a class="cerrar -small" @click="showPopup = false">✕</a>
        <h2 class="title-dato">{{ $t('seleccione_anio_academico') }}:</h2>
        <div class="contenedor-input -select -certificado">
          <select name="anio" v-model="anio" :style="styles.input_black">
            <option value="" v-for="el in aniosAcademicos" :value="el.clave">{{ el.descripcion }}</option>
          </select>
          <button class="button-download" @click="downloadCertificado">{{ $t('descargar') }}</button>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

import salir from '@/components/parts/icons/salir'
import downloadDOC from '@/components/parts/icons/download-doc'

export default {
  name: 'menu-superior',
  mounted() {
    if (this.aniosAcademicos && this.aniosAcademicos.length > 0) {
      this.anio = this.aniosAcademicos[0].clave;
    }
  },
  data: () => ({
    certificadoPracticas: '',
    showPopup: false,
    anio: ''
  }),
  components: {
    'icon-salir': salir,
    'icon-download-doc': downloadDOC
  },
  computed: {
    ...mapGetters({
      styles: 'getStyles',
      doc: 'getDocSuperior',
      name: 'getUserName',
      showMenu: 'getShowMenu',
      brand: 'getBrand',
      lang: 'getLanguage',
      aniosAcademicos: 'getAniosAcademicosCertificado'
    })
  },
  methods: {
    ...mapActions(['logout', 'requestCertificadoPracticasTutorizadas']),
    downloadCertificado() {
      if (!this.anio) {
        return;
      }
      this.requestCertificadoPracticasTutorizadas(this.anio).then(r => {
        if (r && r && r[this.lang]) {
          window.open(r[this.lang], '_blank');
        }
        this.showPopup = false;
      }).catch(e => {
        this.showPopup = false;
        this.$store.dispatch('sendErrorServer', e);
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/colors.scss';

.menu-superior {
  height: $top-height;
  width: 100%;
  padding: 20px;
}

.button {
  text-transform: uppercase;
  font-size: 10px;
  cursor: pointer;
  padding: 0 10px;
  max-height: 45px;

  svg {
    margin-bottom: 5px;
  }

  &.actilla {
    border: 0;
    background: transparent;
    cursor: pointer;

    svg {
      height: 25px;
    }
  }
}

.contenedor-input.-certificado {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 0px;
  padding-bottom: 0px;
  flex-wrap: wrap;

  select {
    max-width: 190px;
    margin-right: 15px;
  }

  .button-download {
    max-width: calc(100% - 190px);
    border: 0;
    background: #709194;
    cursor: pointer;
    color: #fff;
    font-size: 16px;
    text-transform: uppercase;
    padding: 5px 15px;
    border-radius: 16px;
  }
}


.nombre {
  font-size: 18px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 800;
  transition: .7s;
  padding-left: 60px;

  &[move=true] {
    padding-left: 0px;
  }
}

.cover-popup.-certificado {
  .popup {
    max-width: 400px;
    padding: 30px;
  }

  .title-dato {
    font-size: 20px;
  }
}

@media screen and (max-width: 1400px) {
  .menu-superior {
    height: 75px;
    padding: 10px 20px;
  }
}

@media screen and (max-width: 1023px) {
  .nombre {
    max-width: 80%;
    text-align: left;
    font-size: 16px;
  }

  .button.actilla {
    font-size: 0;
  }
}

@media screen and (max-width: 390px) {
  .contenedor-input.-certificado select {
    max-width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/parts/menu-superior.vue